/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


// # Core Utilities
define('global/Core',[
    'jquery',
    'lodash',
    './Logger'
], function ($, _, Logger) {
    'use strict';

    var isProduction;
    var cfg = window.RocConfig;
    var assetsDomain = cfg.assetManager.rocAssetsDomain;

    function getImageUrl(image, width, height) {
        if (!image || !image.asset || !image.asset.path) {
            return '';
        }
        
        return '//' + assetsDomain + '/w' + width.toString() + '-h' + height.toString() + '-cpad/' + image.asset.path;
    }

    function createCookie(name, value, days) {
        var cookie_string = name + '=' + escape(value);

        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            cookie_string += '; expires=' + date.toGMTString();
        }

        document.cookie = cookie_string + '; path=/';
    }

    function readCookie(name) {
        var nameEQ = name + '=';
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = unescape(ca[i]);
            while (c.charAt(0) === ' ') {
                c = c.substring(1, c.length);
        }

            if (c.indexOf(nameEQ) === 0) {
                return c.substring(nameEQ.length, c.length);
            }
        }
        return null;
    }

    function eraseCookie(name) {
        this.createCookie(name, '', -1);
    }

    function getCookie(NameOfCookie) {
        if (document.cookie.length > 0) {
            var begin = document.cookie.indexOf(NameOfCookie + '=');
            if (begin !== -1) {
                begin += NameOfCookie.length + 1;

                var end = document.cookie.indexOf(';', begin);
                if (end === -1) {
                    end = document.cookie.length;
                }

                return unescape(document.cookie.substring(begin, end));
            }
        }
        return null;
    }

    // Ensure that cookie does not exceed 4kb.
    function trimCookieSize(valueArray) {
        //Take off the first two values in the list to reduce size.
        var slicedArray = valueArray.slice(1);
        var newValues = '';
        for (var i = 0; i < slicedArray.length; i++) {
            newValues += slicedArray[i];
        }
        return newValues;
    }

    function lockButton(selector, replacementText) {
        var buttons = $(selector);
        $.each(buttons, function () {
            var button = this;
            switch (button.tagName) {
                case 'A':
                case 'BUTTON':
                    button.setAttribute('data-orgvalue', button.innerHTML);
                    if (typeof replacementText === 'undefined') {
                        button.innerHTML = ' Please wait...';
                    } else {
                        button.innerHTML = replacementText;
                    }
                    if (button.tagName === 'BUTTON') {
                        button.disabled = true;
                    }
                    break;
                case 'INPUT':
                    button.setAttribute('data-orgvalue', button.value);
                    if (typeof replacementText === 'undefined') {
                        button.value = ' Please wait...';
                    } else {
                        button.value = replacementText;
                    }
                    button.disabled = true;
                    break;
            }
        });
    }

    function releaseLockedButton(selector) {
        var buttons = $(selector);
        $.each(buttons, function () {
            var button = this;
            var originalValue = button.getAttribute('data-orgvalue');
            switch (button.tagName) {
                case 'A':
                case 'BUTTON':
                    if (originalValue !== null) {
                        button.innerHTML = originalValue;
                    }
                    if (button.tagName === 'BUTTON') {
                        button.disabled = false;
                    }
                    break;
                case 'INPUT':
                    if (originalValue !== null) {
                        button.value = originalValue;
                    }
                    button.disabled = false;
                    break;
            }
        });
    }

    function handleEnter(selector, clb) {
        $('body').on('keypress', selector, function (e) {
            if (e.keyCode === 13) {
                clb(e);
            }
        });
    }
 
    // Method to load scripts dynamically and to cache the script results
    function cachedScript(url, options) {
        // Allow user to set any option except for dataType, cache, and url
        options = $.extend(options || {}, {
            dataType: 'script',
            cache: true,
            url: url
        });

        // Use $.ajax() since it is more flexible than $.getScript
        // Return the xhr object so we can chain callbacks
        return jQuery.ajax(options);
    };

    function cloneJsObject(object) {
        return (JSON.parse(JSON.stringify(object)));
    };

    function isJson(item) {
        item = typeof item !== 'string'
            ? JSON.stringify(item)
            : item;

        try {
            item = JSON.parse(item);
        } catch (e) {
            return false;
        }

        if (typeof item === 'object' && item !== null) {
            return true;
        }

        return false;
    }

    function toString(val) {
      if (val === null) {
        return '';
        } else {
        return val.toString();
        }
    };

    function isUndefined(value) {
        return typeof value === 'undefined' || toString.call(value) === '[object Function]' || (value.hash !== null);
    }

    function getModelStateErrors(xhr) {
        var errors = [];
        if (xhr.status === 400 && xhr.responseJSON && xhr.responseJSON.modelState) {
            var modelState = xhr.responseJSON.modelState;
            for (var error in modelState) {
                if (modelState.hasOwnProperty(error)) {
                    _.forEach(modelState[error], function (v) { errors.push(v); });
                }
            }
        }
        return errors;
    }
        
    function getValueByPath(obj, path) {
        var splitPath = path.split('.');
        for (var i = 0, len = splitPath.length; i < len; i++) {
            try {
                obj = obj[splitPath[i]];
            } catch (e) {
                return null;
            }
        };
        return obj;
    };

    function setValueByPath(obj, path, value) {
        var result = obj,
            i;
        for (i = 0; i < path.length - 1; i++) {
            try {
                result = result[path[i]];
            }
            catch (e) {
                return;
            }
        }

        if (typeof value == 'object') {
            result[path[i]] = value;
        }
    }

    function checkSiteMode() {
        isProduction = $('html').data('rocIsProduction');
        return isProduction;
    }

    function getCustomValue(model, attributeName) {
        if (!model || !model.customFields || model.customFields[attributeName] === null || model.customFields[attributeName] === undefined ||
            $.isPlainObject(model.customFields[attributeName]) || ($.isArray(model.customFields[attributeName]) && model.customFields[attributeName].length === 0)) {
            return null;
        }

        return $.isArray(model.customFields[attributeName])
            ? model.customFields[attributeName][0].value
            : model.customFields[attributeName];
    }

    function init() {
        $.ajaxSetup({
            cache: false
        });

        $(document).bind('ajaxSend', function (event, xhr, settings) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + getCookie('access_token'));

            var impersonationCookie = getCookie('ImpersonationSession');
            if (impersonationCookie) {
                xhr.setRequestHeader('Roc-Impersonation', impersonationCookie);
            }
        });

        checkSiteMode();

        if (isProduction === false) {
            Logger.warn('Site is currently running is dev mode. Should be set to production mode on server.');
        };
    }

    init();

    var Core = {
        createCookie: createCookie,
        readCookie: readCookie,
        eraseCookie: eraseCookie,
        getCookie: getCookie,
        trimCookieSize: trimCookieSize,
        lockButton: lockButton,
        releaseLockedButton: releaseLockedButton,
        handleEnter: handleEnter,
        cachedScript: cachedScript,
        cloneJsObject: cloneJsObject,
        isJson: isJson,
        getImageUrl: getImageUrl,
        isUndefined: isUndefined,
        toString: toString,
        checkSiteMode: checkSiteMode,
        getValueByPath: getValueByPath,
        setValueByPath: setValueByPath,
        getModelStateErrors: getModelStateErrors,
        getCustomValue: getCustomValue
    };

    Logger.debug('Core.js Loaded:', Core);

    return Core;
});

